import { useEffect, useState } from 'react';
import { getWeeksBetween } from '../../../../../lib/date';
import { EllipsisHorizontalIcon } from '@heroicons/react/16/solid';

const Weekly = ({ challenge, refresh, closeDetailDialog }) => {
  const [weeks, setWeeks] = useState([]);

  useEffect(() => {
    if (challenge.id) {
      const weeksBetween = getWeeksBetween(
        new Date(challenge.startDate),
        new Date(challenge.endDate)
      );
      setWeeks(weeksBetween);
    }
  }, [challenge]);

  return (
    <div>
      <div className='relative'>
        <img
          src={challenge.bannerUrl}
          alt='challenge'
          className='h-36 w-full rounded-t-xl object-cover object-center'
        />
        <div className='absolute top-0 left-0 right-0 bottom-0 bg-gradient-to-t from-white rounded-t-xl'></div>
        <div className='absolute top-2 right-3 flex items-center gap-4'>
          <div className='border-2 rounded-full size-5 flex justify-center items-center text-white font-bold'>
            i
          </div>
          <EllipsisHorizontalIcon
            className='text-gray-200 size-6'
            // onClick={openBottomDialog}
          />
        </div>
      </div>
      <div className='mt-4 mb-8'>
        {weeks.map((week, index) => (
          <div
            key={index}
            className='mb-4'
          >
            <h2 className='uppercase text-xs font-bold mb-2'>
              Week {week.week}
            </h2>
            <div className='border rounded-xl px-3 py-2 grid grid-cols-4 gap-4'>
              {[1, 2, 3, 4, 5, 6, 7, 8].map((day) => (
                <div
                  key={index}
                  className={`flex justify-center items-center`}
                >
                  {day === 8 ? (
                    <div className='text-4xl grayscale'>🏆</div>
                  ) : (
                    <button className='flex justify-center items-center border rounded-full size-12 font-bold text-gray-400'>
                      {day}
                    </button>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Weekly;
